import { InjectionToken } from '@angular/core'
import { SupportEnvironment } from '../../multi-environment/support-environment'

/** Where a conversation opens: inside the app that is showing the list, with the environment it belongs to. */
export type ConversationLinkBuilder = (environment: SupportEnvironment, intercomId: string) => unknown[]

/**
 * The main app hosts the conversation page under its support section and serves one environment;
 * Atlas hosts its own copy and has to say which environment the id belongs to. Each app provides
 * the builder that matches its routes.
 */
export const CONVERSATION_LINK = new InjectionToken<ConversationLinkBuilder>('CONVERSATION_LINK', {
  providedIn: 'root',
  factory: () => (_environment, intercomId) => ['/app', 'support', 'conversations', intercomId],
})

export const atlasConversationLink: ConversationLinkBuilder = (environment, intercomId) => ['/conversations', environment.key, intercomId]
